<template>
    <ClassroomLayout>
        <div class="classroom-lobby">
            <h3>Your teacher will let you in soon</h3>
        </div>
        <CountdownTimer 
            v-if="countingDown" 
            :start-time-utc="startTimeUtc" 
            @ended="onCountdownEnded"
        />
    </ClassroomLayout>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import ClassroomLayout from "@/components/classroom/ClassroomLayout.vue";
import CountdownTimer from "@/components/CountdownTimer.vue";

const props = defineProps({
    startTimeUtc: Number
});

const isFinished = ref(false);

// The countdown shows as long as the start time is in the future 
// AND the timer hasn't naturally finished.
const countingDown = computed(() => {
    if (isFinished.value) return false;
    return props.startTimeUtc && (props.startTimeUtc > Date.now());
});

function onCountdownEnded() {
    isFinished.value = true;
}
</script>

<style lang="scss" scoped>
.classroom-lobby {
    text-align: center;

    h3 {
        margin-bottom: 50px
    }
}
</style>